import resume from '../assets/pdf/resume.pdf'

export const headerData = {
    name: 'Equerre-Studio ',
    title: "Equerre Studio",
    desciption:"",
    image: 'https://avatars.githubusercontent.com/u/85482640?v=4',
    resumePdf: resume
}
